/**
 * CenterMarker Component
 * Displays a red marker at the center of the map
 */

import React, { useEffect, useRef } from "react";
import { useMap } from "@vis.gl/react-google-maps";
import { HoverInfo } from "@/util/http/WeevilTrak/responseType";

interface CenterMarkerProps {
    position: { lat: number; lng: number };
    locationName?: string;
    stage?: string;
    predictionDate?: string;
    predictionStageDate?: string;
    predictedDays?: number;
    onHover: (info: HoverInfo | null) => void;
}

export const CenterMarker: React.FC<CenterMarkerProps> = ({ position, locationName, stage, predictionDate, predictionStageDate, predictedDays, onHover }) => {
    const map = useMap();
    const markerRef = useRef<google.maps.Marker | null>(null);
    const circleRef = useRef<google.maps.Circle | null>(null);

    // 根据 zoom 计算半径的函数，目标是让圆圈在视觉上保持约 20px 直径
    const getRadiusForZoom = (zoom: number) => {
        // 这是一个经验公式：在 Zoom 0 时，半径设为较大的值，随缩放每级减半
        // 也可以使用更精确的：metersPerPixel = 156543.03392 * Math.cos(lat * Math.PI / 180) / Math.pow(2, zoom)
        return 156543 / Math.pow(2, zoom) * 10;
    };

    useEffect(() => {
        if (!map) return;

        // Clean up existing marker
        // if (markerRef.current) {
        //     google.maps.event.clearInstanceListeners(markerRef.current);
        //     markerRef.current.setMap(null);
        // }
        if (circleRef.current) {
            google.maps.event.clearInstanceListeners(circleRef.current);
            circleRef.current.setMap(null);
        }
        if(position?.lat === 0 && position.lng === 0) {
            return;
        }

        // 初始化 Circle
        const circle = new google.maps.Circle({
            map: map,
            center: position,
            radius: getRadiusForZoom(map.getZoom() || 10),
            fillColor: "red",
            fillOpacity: 1,
            strokeColor: "darkred",
            strokeWeight: 2,
            zIndex: 1000,
            clickable: true
        });

        // 监听缩放以实时调整半径
        const zoomListener = map.addListener("zoom_changed", () => {
            const newZoom = map.getZoom();
            if (newZoom !== undefined) {
                circle.setRadius(getRadiusForZoom(newZoom));
            }
        });

        // 绑定事件
        circle.addListener("mouseover", (e: any) => {
            onHover({
                placeId: "center",
                lat: position.lat,
                lng: position.lng,
                value: predictedDays,
                predictionDate: predictionDate,
                predictedStageDate: predictionStageDate,
                locationName: locationName,
                stage: stage,
                mouseX: e.domEvent.clientX,
                mouseY: e.domEvent.clientY,
                isCenter: true
            });
        });

        circle.addListener("mouseout", () => {
            onHover(null);
        });

        circleRef.current = circle;


        // const marker = new google.maps.Marker({
        //     position: position,
        //     map: map,
        //     icon: {
        //         path: google.maps.SymbolPath.CIRCLE,
        //         scale: 7,
        //         fillColor: "red",
        //         fillOpacity: 1,
        //         strokeColor: "darkred",
        //         strokeWeight: 2
        //     },
        //     zIndex: 10
        // });

        // marker.addListener("mouseover", (e: any) => {
        //     onHover({
        //         placeId: "center",
        //         lat: position.lat,
        //         lng: position.lng,
        //         value: predictedDays,
        //         predictionDate: predictionDate,
        //         predictedStageDate: predictionStageDate,
        //         locationName: locationName,
        //         stage: stage,
        //         mouseX: e.domEvent.clientX,
        //         mouseY: e.domEvent.clientY,
        //         isCenter: true
        //     });
        // });

        // marker.addListener("mouseout", () => {
        //     onHover(null);
        // });

        // markerRef.current = marker;

        return () => {
            // if (markerRef.current) {
            //     google.maps.event.clearInstanceListeners(markerRef.current);
            //     markerRef.current.setMap(null);
            // }
            google.maps.event.removeListener(zoomListener);
            if (circleRef.current) {
                google.maps.event.clearInstanceListeners(circleRef.current);
                circleRef.current.setMap(null);
            }
        };
    }, [map, position, onHover]);

    return null;
};
